import React from 'react';
import {
    makeStyles,
    Container,
    Grid,
    Paper,
    Typography,
    Switch,
    withStyles,
    createStyles,
    Box,
    Dialog,
} from '@material-ui/core';
import moment from 'moment';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import TodayLeave from './component/TodayLeave';
import Balance from '../LeaveApplication/component/Balance';
import customAxios from '../API/customAxios';
import { FormattedMessage } from 'react-intl';
import { AntSwitch } from '../UIComponent/AntSwitch';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';
import { Calendar } from "react-modern-calendar-datepicker";
import { isMobile } from "react-device-detect";

import SINGLE_TICK from "./assets/single_tick.svg";
import DOUBLE_TICK from "./assets/double_tick.svg";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    paperWithoutPadding: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    welcomeMessage: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
    },
    textBold: {
        fontSize: isMobile ? 13 : 16,
        fontWeight: 600,
    },
    todayLeaveContainer: {
        padding: 12,
    },
    todayLeaveHeader: {
        fontSize: 16,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    flexCenter: {
        display: 'flex',
        alignItems: 'center',
    },
    calendarIcon: {
        color: '#000',
    },
    paddingTop: {
        paddingTop: 2,
    },
    mobileToggleContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    mobileToggleItem: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    imageSize: {
        height: 23,
    },
    marginLeft: {
        marginLeft: 15,
    }
}));

export default function Home() {
    const mode = window.global.homeMode;
    const classes = useStyles();
    const intl = useIntl();
    const [userData, setUserData] = React.useState({
        user_role: null,
        annual_allowances: null,
    });
    const [showBalance, setShowBalance] = React.useState(true);
    const [gridItemLg, setGridItemLg] = React.useState(12);
    const [toggle, setToggle] = React.useState(false);
    const [showCalendar, setShowCalendar] = React.useState(false);
    const [targetLeaveDate, setTargetLeaveDate] = React.useState(
        moment().format('YYYY-MM-DD')
    );
    const [selectedDay, setSelectedDay] = React.useState({
        day: moment().date(),
        month: moment().month() + 1,
        year: moment().year()
    });
    const [targetLeaveTitle, setTargetLeaveTitle] = React.useState(
        intl.formatMessage({ id: 'home.today' })
    );

    React.useEffect(() => {
        customAxios.get(`/get_user_record`).then((res) => {
            setUserData(res.data);

            if (res.data['user_role'] === window.global.hrAdmin) {
                setShowBalance(false);
                setGridItemLg(6);
            }
        });
    }, []);

    const handleChangeToggle = () => setToggle(!toggle);
    const handleShowCalendar = () => setShowCalendar(true);
    const handleCloseCalendar = () => setShowCalendar(false);

    const onLeaveDateChange = (value: string) => {
        const date = moment({year: value.year, month: value.month - 1, day: value.day});
        const leaveDate = date.format('YYYY-MM-DD');

        setTargetLeaveDate(leaveDate);
        getTargetDateTitle(leaveDate);
        setSelectedDay(value);
        handleCloseCalendar();
    };

    function getCurrentDate() {
        const newDate = new Date();
        let resultDate;
        if (localStorage.getItem('locale') === 'zh') {
            import('moment/locale/zh-tw');
            resultDate = moment(newDate).format('dddd, YYYY年M月DD日');
        } else if (localStorage.getItem('locale') === 'en') {
            resultDate = moment(newDate).format('ddd, MMM DD, YYYY');
        }
        return resultDate;
    }

    const getTargetDateTitle = (targetDate) => {
        const today = moment().format('YYYY-MM-DD');
        const isZH = localStorage.getItem('locale') === 'zh';

        if (today === targetDate) {
            setTargetLeaveTitle(isZH ? '今天' : "Today's ");
        } else {
            setTargetLeaveTitle(
                isZH
                    ? moment(targetDate).locale('zh-tw').format('YYYY年M月D日')
                    : moment(targetDate).format('D MMM YYYY')
            );
        }
    };

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth='lg' className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography
                            component='h1'
                            variant='h5'
                            align='left'
                            className={classes.welcomeMessage}
                        >
                            <FormattedMessage id='home.welcome' />
                        </Typography>
                        <Typography
                            component='h1'
                            variant='h5'
                            align='left'
                            className={classes.textBold}
                        >
                            <FormattedMessage id='home.todayis' />{' '}
                            {getCurrentDate()}
                        </Typography>
                    </Grid>

                    <Grid item lg={gridItemLg} xs={12}>
                        {showBalance ? (
                            <Paper className={classes.paper}>
                                <Balance
                                    mode={mode}
                                    annualAllowances={userData.annual_allowances}
                                    compLeaveAllowances={userData.comp_leave_allowances}
                                />
                            </Paper>
                        ) : (
                            <Paper className={classes.paperWithoutPadding}>
                                <img src='/images/Banner_of_SUNeVision.png' />
                            </Paper>
                        )}
                    </Grid>

                    <Grid container className={classes.todayLeaveContainer}>
                        <Grid className={classes.todayLeaveHeader}>
                            <Box className={classes.flexCenter}>
                                <Typography
                                    className={`${classes.textBold} ${classes.paddingTop}`}
                                >
                                    {targetLeaveTitle}
                                    <FormattedMessage id='home.employeeOnLeave' />
                                </Typography>
                                <IconButton
                                    aria-label='target date leave'
                                    onClick={() => handleShowCalendar()}
                                >
                                    <CalendarMonthIcon
                                        className={classes.calendarIcon}
                                    />
                                </IconButton>
                            </Box>
                            <Grid className={`${classes.root} ${classes.textBold} ${isMobile ? classes.mobileToggleContainer : ''}`}>
                                <Box className={`${classes.flexCenter} ${classes.marginLeft} ${isMobile ? classes.mobileToggleItem : ''}`}>
                                    <img src={SINGLE_TICK} alt="single tick" className={classes.imageSize} />
                                    <FormattedMessage id='leave_approval.show_approved' />
                                    <AntSwitch
                                        checked={toggle}
                                        onChange={handleChangeToggle}
                                        name='show_pending'
                                    />
                                </Box>
                                <Box className={`${classes.flexCenter} ${classes.marginLeft} ${isMobile ? classes.mobileToggleItem : ''}`}>
                                    <img src={DOUBLE_TICK} alt="double tick" className={classes.imageSize} />
                                    <FormattedMessage id='leave_approval.show_endorsed' />
                                    <AntSwitch
                                        checked={true}
                                        name='show_endorsed'
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <div className={classes.todayLeaveTable}>
                                <Paper>
                                    <TodayLeave
                                        toggle={toggle}
                                        targetLeaveDate={targetLeaveDate}
                                    />
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>

            <Dialog onClose={handleCloseCalendar} open={showCalendar}>
                    <Calendar
                        value={selectedDay}
                        onChange={(value) => onLeaveDateChange(value)}
                        shouldHighlightWeekends
                    />
            </Dialog>
        </main>
    );
}
